export default "__VITE_ASSET__841939ef__"